module.exports = __webpack_public_path__ + "assets/img/SpinTel-Social-Static-Ad.11000fd9.png";